// =============================================================================
// EmptyBlock — se muestra cuando un bloque del dashboard viene null
// (degradación elegante del backend). Mensaje neutro sin alarmar al usuario.
// =============================================================================

interface EmptyBlockProps {
  title: string;
  message?: string;
}

export function EmptyBlock({
  title,
  message = 'No se pudo calcular esta sección. Vuelve a intentarlo en unos instantes.',
}: EmptyBlockProps) {
  return (
    <section className="bg-white rounded-2xl border border-slate-200 p-6">
      <h2 className="text-base font-semibold text-slate-900 mb-3">{title}</h2>
      <div className="flex items-center gap-3 text-slate-500 text-sm">
        <span className="material-symbols-outlined text-xl text-slate-400">info</span>
        {message}
      </div>
    </section>
  );
}
